import React from 'react';
import TPEAction from 'src/models/common/TPEAction';
import ServiceCollection from 'src/services/ServiceCollection';
import { DerivedAllocationSheetBuilderState } from './DerivedAllocationSheetBuilderState';

/** Context of the derived allocation sheet builder, read by the step sections. */
export interface DerivedAllocationSheetBuilderContextType {
    dasState: DerivedAllocationSheetBuilderState;
    dasDispatch: React.Dispatch<TPEAction>;
    services: ServiceCollection;
    sheetId: string;
}

export const DerivedAllocationSheetBuilderContext =
    React.createContext(null as unknown as DerivedAllocationSheetBuilderContextType);
